export const money = (value = 0) => new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP'
}).format(Number(value));

export const date = (value) => value ? new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric'
}).format(new Date(value)) : '—';

export const time = (value) => value ? new Intl.DateTimeFormat('en-GB', {
  hour: '2-digit',
  minute: '2-digit'
}).format(new Date(value)) : '—';

export const dateTime = (value) => value ? `${date(value)}, ${time(value)}` : '—';

export const relativeDate = (value) => {
  const difference = Math.round((new Date(value) - new Date()) / 86400000);
  if (difference === 0) return 'Today';
  if (difference === 1) return 'Tomorrow';
  if (difference === -1) return 'Yesterday';
  return difference > 0 ? `In ${difference} days` : `${Math.abs(difference)} days ago`;
};

export const invoiceTotal = (invoice) => (invoice.line_items || []).reduce((sum, item) => sum + item.quantity * item.unit_price, 0);